module.exports = new __parcel__URL__("lexus-upload.980c7877.png").toString();